// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"126":"72523fd8","431":"98cc58b4","489":"fd7fc32d","507":"b829b003","608":"94a80f34","880":"07c00279"}[chunkId] + ".chunk.js";
};